(() => {
  if (customElements.get('bas-campaign-banner')) return;
  const zone = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  const localParts = time => Object.fromEntries(zone.formatToParts(time).map(part => [part.type, part.value]));
  const parseSchedule = value => {
    if (!value.trim()) return null;
    const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!match) return NaN;
    const [, year, month, day, hour, minute] = match;
    const nominal = Date.UTC(+year, +month - 1, +day, +hour, +minute);
    for (const offset of [6, 7]) {
      const candidate = nominal + offset * 3600000;
      const parts = localParts(candidate);
      if (parts.year === year && parts.month === month && parts.day === day && parts.hour === hour && parts.minute === minute) return candidate;
    }
    return NaN;
  };
  let clockOffset = 0;
  const now = () => Date.now() + clockOffset;
  const syncClock = () => fetch(window.location.pathname + '?_bb_clock=' + Date.now(), { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' }).then(response => {
    const serverTime = Date.parse(response.headers.get('date'));
    if (Number.isFinite(serverTime)) clockOffset = serverTime - Date.now();
    document.querySelectorAll('bas-campaign-banner').forEach(banner => banner.refresh());
  }).catch(() => {});
  const measurePinned = () => {
    let height = 0;
    document.querySelectorAll('bas-campaign-banner').forEach(banner => {
      if (!banner.hidden && banner.dataset.sticky === 'true') {
        banner.wrapper.style.setProperty('--bb-stack-top', `${height}px`);
        height += banner.wrapper.getBoundingClientRect().height;
      }
    });
    document.documentElement.style.setProperty('--bb-pinned-height', `${height}px`);
    document.documentElement.classList.toggle('bb-has-pinned-banner', height > 0);
  };
  class CampaignBanner extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.section-bas-campaign') || this.parentElement;
      this.editor = this.dataset.editor === 'true';
      this.start = parseSchedule(this.dataset.start || '');
      this.end = parseSchedule(this.dataset.end || '');
      this.media = window.matchMedia('(max-width: 749px)');
      this.refreshBound = this.refresh.bind(this);
      this.media.addEventListener('change', this.refreshBound);
      document.addEventListener('visibilitychange', this.refreshBound);
      window.addEventListener('pageshow', this.refreshBound);
      this.resizeObserver = new ResizeObserver(measurePinned);
      this.resizeObserver.observe(this.wrapper);
      this.refresh();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.resizeObserver?.disconnect();
      this.media?.removeEventListener('change', this.refreshBound);
      document.removeEventListener('visibilitychange', this.refreshBound);
      window.removeEventListener('pageshow', this.refreshBound);
      measurePinned();
    }
    refresh() {
      clearTimeout(this.timer);
      const time = now();
      const invalid = Number.isNaN(this.start) || Number.isNaN(this.end) || (this.start !== null && this.end !== null && this.end <= this.start);
      const enabled = this.dataset.enabled === 'true';
      const device = this.media.matches ? this.dataset.mobile !== 'false' : this.dataset.desktop !== 'false';
      const started = this.start === null || time >= this.start;
      const ended = this.end !== null && time >= this.end;
      this.hidden = !this.editor && (!enabled || invalid || !device || !started || ended);
      this.wrapper.classList.toggle('bb-pinned', !this.hidden && this.dataset.sticky === 'true');
      const status = this.querySelector('.bb-editor-status');
      if (status) {
        const state = invalid ? 'Invalid schedule. Use YYYY-MM-DD HH:mm; end must follow start. Publicly hidden.' : !enabled ? 'Switched off. Visible here for editing only.' : !started ? `Scheduled to start ${this.dataset.start}.` : ended ? 'Campaign ended. Publicly hidden.' : !device ? 'Hidden on this device. Editor preview only.' : 'Banner is enabled and currently within its schedule.';
        status.textContent = `Editor preview: ${state} Schedule time zone: Denver / Mountain.`;
      }
      measurePinned();
      const boundaries = [this.start, this.end].filter(value => value !== null && value > time);
      const delay = boundaries.length ? Math.min(60000, Math.max(1, Math.min(...boundaries) - time)) : 60000;
      this.timer = setTimeout(() => this.refresh(), delay);
    }
  }
  customElements.define('bas-campaign-banner', CampaignBanner);
  syncClock();
  window.addEventListener('focus', syncClock);
})();

